import classNames from 'classnames';
import React from 'react';
import { useTheme } from 'styled-components';
import { getTagColor, ICON_SIZE_MAP, tagClasses, TagSC } from './tag.styled';
import { TagProps } from './tag.types';

const Tag: React.FunctionComponent<TagProps> = ({
  variant = 'default',
  className,
  Icon,
  children,
  size = 'large',
  ...rest
}) => {
  const theme = useTheme();

  const colors = React.useMemo(() => getTagColor(theme, variant), [theme, variant]);

  return (
    <TagSC
      className={classNames(
        tagClasses.component,
        className,
        `${tagClasses.component}-${variant}`,
        `${tagClasses.component}-${size}`,
        {
          [`${tagClasses.component}-has-icon`]: !!Icon,
        },
      )}
      colors={colors}
      {...rest}
    >
      {Icon ? (
        <Icon {...ICON_SIZE_MAP[size]} className={tagClasses.icon} color={colors.icon} />
      ) : null}
      {children !== undefined || children !== null ? (
        <span className={tagClasses.label}>{children}</span>
      ) : null}
    </TagSC>
  );
};

export default Tag;
